import { NgModule } from "@angular/core";
import {
  BrowserModule,
  HAMMER_GESTURE_CONFIG,
} from "@angular/platform-browser";
import { RouteReuseStrategy } from "@angular/router";

import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { HttpClientModule } from "@angular/common/http";
import { Deeplinks } from "@ionic-native/deeplinks/ngx";
import { AngularFireModule } from "@angular/fire";
import { AngularFireAuthModule } from "@angular/fire/auth";
import { AngularFireDatabaseModule } from "@angular/fire/database";
import {
  AngularFirestoreModule,
  AngularFirestore,
} from "@angular/fire/firestore";
import { environment } from "../environments/environment";
import { Geolocation } from "@ionic-native/geolocation/ngx";
import { NativeGeocoder } from "@ionic-native/native-geocoder/ngx";
import { UserService } from "../providers/user.service";
import { NativeStorage } from "@ionic-native/native-storage/ngx";
import { EmailComposer } from "@ionic-native/email-composer/ngx";
import { IonicStorageModule } from "@ionic/storage";
import { NgbModalModule } from "@ng-bootstrap/ng-bootstrap";
import { AngularFireStorageModule } from "@angular/fire/storage";
import { Connectivity } from "./providers/connectivity-service";
import { AngularFireFunctionsModule } from "@angular/fire/functions";
import { SocialSharing } from "@ionic-native/social-sharing/ngx";
import { FirebaseDynamicLinks } from "@ionic-native/firebase-dynamic-links/ngx";
import { DatePipe } from "@angular/common";
import { Camera } from "@ionic-native/camera/ngx";
import { File } from "@ionic-native/file/ngx";
import { InAppBrowser } from "@ionic-native/in-app-browser/ngx";
import { Network } from "@ionic-native/network/ngx";
import { LaunchNavigator } from "@ionic-native/launch-navigator/ngx";
import { AppLauncher } from "@ionic-native/app-launcher/ngx";
import { LocalNotifications } from "@ionic-native/local-notifications/ngx";
import { PhonegapLocalNotification } from "@ionic-native/phonegap-local-notification/ngx";
import { IonicGestureConfig } from "./utils/IonicGestureConfig";

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAuthModule,
    AngularFireDatabaseModule,
    AngularFirestoreModule,

    BrowserModule,
    AngularFireStorageModule,
    NgbModalModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    IonicStorageModule,
    IonicStorageModule.forRoot(),
    AngularFireFunctionsModule,
    HttpClientModule,
  ],
  providers: [
    PhonegapLocalNotification,
    LocalNotifications,
    LaunchNavigator,
    AppLauncher,
    Connectivity,
    Network,
    UserService,
    Camera,
    File,
    AngularFirestoreModule,
    Geolocation,
    NativeGeocoder,
    StatusBar,
    AngularFirestore,
    SplashScreen,
    NativeStorage,
    EmailComposer,
    SocialSharing,
    FirebaseDynamicLinks,
    DatePipe,
    Deeplinks,
    InAppBrowser,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HAMMER_GESTURE_CONFIG, useClass: IonicGestureConfig },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
